// extracted by mini-css-extract-plugin
module.exports = {"controller":"activity-control_controller__Jdif8"};